import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const GetResults = async (token, idCenter) => {
    try {
        const dataToSend = {
            idCenter: idCenter
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V3/Api/GetEvaluationsResults"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response?.message }
        }

        // // //const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/GetEvaluationsResults", {
        // // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V3/Api/GetEvaluationsResults", {
        // //     method: 'POST',
        // //     headers: {
        // //         'Content-Type': 'application/json',
        // //         'Authorization': token
        // //     },
        // //     body: JSON.stringify(dataToSend)
        // // })
        
        // // if (!response.ok) {
        // //     // Manejar errores HTTP
        // //     const errorData = await response.json()
        // //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        // //     return { success: false, message: errorData.message } //errorCode
        // // }
        
        // // const data = await response.json()
        
        // // // Retornar la respuesta exitosa
        // // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetResults DL Results', error)
        return { success: false, message: 'No ha sido posible obtener los resultados de tus evaluaciones' }
    }
}

export { GetResults };